<template>
  <div>
    <myDialog
      class="ArriveMidway_Dia"
      diaWidth="600px"
      dialogTitle="选择打印"
      :isAppend="true"
      :isShowDialog="isShowDialog"
      @handleCloseDia="isShowDialog = false"
      @diaCancelBtn="isShowDialog = false"
      confirmText="打印"
      @diaConfirmBtn="printEvent()"
    >
      <div class="glo_dialogForm">
        <el-form class="diaForm" :model="params" label-width="80px">
          <el-form-item
            label="筛选条件"
            prop="conditionType"
            style="width: 100%"
          >
            <el-radio-group
              v-model="params.conditionType"
              @change="changeConditionType"
            >
              <el-radio :label="1">按运输路线</el-radio>
              <el-radio :label="2">按目的城市</el-radio>
              <el-radio :label="3">按到达网点</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="交接方式" prop="conditionType">
            <el-checkbox-group v-model="params.sendMethodConfIds">
              <el-checkbox
                :label="sendMethod.id"
                v-for="sendMethod in sendMethods"
                :key="sendMethod.id"
              >
                {{ sendMethod.val }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <el-table
          :data="datas"
          :header-cell-style="{
            background: '#EBEEF5',
          }"
          max-height="300"
        >
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column type="selection" label=""></el-table-column>
          <el-table-column
            label="运输线路"
            prop="lineName"
            v-if="params.conditionType === 1"
          ></el-table-column>
          <el-table-column
            label="目的城市"
            prop="destCity"
            v-if="params.conditionType === 2"
          ></el-table-column>
          <el-table-column
            label="终端网点"
            prop="arriveDeptName"
            v-if="params.conditionType === 3"
          ></el-table-column>
        </el-table>
      </div>
    </myDialog>
    <my-print
      :classNameArr="classNameArr"
      :modelClassName.sync="modelClassName"
      modelTypeVal="调度配载模块"
      ref="myPrint"
      :dataSource="printDataSource"
      :add-permission="'admin:dispatch:checixiangqing:print:add:common'"
      :edit-permission="'admin:dispatch:checixiangqing:print:edit:common'"
      :del-permission="'admin:dispatch:checixiangqing:print:del:common'"
    ></my-print>
  </div>
</template>

<script>
import MyPrint from "@/components/print/MyPrint.vue";
import myDialog from "@/components/Dialog.vue";
export default {
  props: {
    dispatchId: {},
  },
  components: {
    MyPrint,
    myDialog,
  },
  data() {
    return {
      classNameArr: [
        {
          name: "发车单",
          val: "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchFcPrintDataV5VO",
        },
      ], // 默认的模板类型
      modelClassName:
        "com.bami.service.tms.v5.admin.dispatch.vo.print.AdminDispatchFcPrintDataV5VO",
      isShowDialog: false,
      params: {
        conditionType: 3,
        sendMethodConfIds: [],
      },
      sendMethods: [],
      lines: [],
      destCities: [],
      arriveDepts: [],
      datas: [],
    };
  },
  methods: {
    async printIt() {
      await this.getSendMethods();
      this.getArrivieDepts();
      this.isShowDialog = true;
    },
    printDataSource(rows, modelClassName) {
      return new Promise((resolve, reject) => {
        this.$API
          .fcPrintData({
            dispatchIds: [this.dispatchId]
          })
          .then((res) => {
            const result = res.data.result;
            resolve(result);
          })
          .catch((err) => {});
      });
    },
    async printEvent() {
        // 获取数据
        const res = await this.$API.fcPrintData({
            dispatchIds : [this.dispatchId]
        })
        this.$refs.myPrint.printEvent(res.data.result)
    },
    // 根据字典类型获取字典值下拉列表 包装 车型 外发提货 外发送货方式
    async getSendMethods() {
      const res = await this.$API.wtl_getConfDictValDownListV5("send_method");
      let arrs = res || [];
      this.sendMethods = arrs;
      this.params.sendMethodConfIds = arrs.map((item) => item.id);
    },
    changeConditionType() {
      switch (this.params.conditionType) {
        case 1:
          this.getLines();
          break;
        case 2:
          this.getDestCities();
          break;
        case 3:
          this.getArrivieDepts();
          break;
      }
    },
    async getLines() {
      const res = await this.$API.runList({
        number: "admin_dispatch_waybill_transport_line",
        dispatchId: this.dispatchId,
      });
      this.lines = res || [];
      this.datas = res;
    },
    async getArrivieDepts() {
      const res = await this.$API.runList({
        number: "admin_dispatch_waybill_arrive_dept",
        dispatchId: this.dispatchId,
      });
      this.arriveDepts = res || [];
      this.datas = res;
    },
    async getDestCities() {
      const res = await this.$API.runList({
        number: "admin_dispatch_waybill_dest_city",
        dispatchId: this.dispatchId,
      });
      this.destCities = res || [];
      this.datas = res;
    },
  },
};
</script>

<style>
</style>